module.exports = __webpack_public_path__ + "img/alerta.5322a9c3.svg";